import { Component, Inject, OnInit, QueryList, ViewChildren} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, } from '@angular/material/dialog';
import { MainService } from 'src/app/services/main.service';
import { StoreService } from 'src/app/services/store.service';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Subscription } from 'rxjs/internal/Subscription';
import { MatSelect } from '@angular/material/select';
import { StoresAttrValidationComponent } from '../stores-attr-validation/stores-attr-validation.component';

@Component({
  selector: 'app-stores-attributes-edit',
  templateUrl: './stores-attributes-edit.component.html',
  styleUrls: ['./stores-attributes-edit.component.scss']
})
export class StoresAttributesEditComponent implements OnInit {

  @ViewChildren('input3') matSelects!: QueryList<MatSelect>;
  @ViewChildren('input1') booleanSelects!: QueryList<MatSelect>;

  dataRow : any;
  attributes : any;
  types = [{ type_id : 1, name : "SI/NO"}, { type_id : 2, name : "FECHA"}, { type_id : 3, name : "OPCIONES"}, { type_id : 6, name : "NÚMERO"}, { type_id : 4, name : "RANGO"}, { type_id : 5, name : "TEXTO"}];
  minDate : Date = new Date();
  startDate : Date = new Date();
  relation : any;
  numberAtributes : number = 0;
  validationsMessages : string = "";
  errorsMessages : string = "";
  atributeRules : Array<any> = [];
  changedAttributeIds = new Set<number>();
  clearedAttributeIds = new Set<number>();
  uploadWarnings : Array<any> = [];

  // validationSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  // validationSubscription: Subscription | undefined;

  // saveSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  // saveSubscription: Subscription | undefined;

  constructor(@Inject(MAT_DIALOG_DATA) public data : any,
    private dialogRef: MatDialogRef<StoresAttributesEditComponent>,
    private matDialog: MatDialog,
    private main : MainService,
    private storeS: StoreService,) { 
      this.attributes = this.data.attributes;
      this.dataRow = this.data.data;
 
      this.relation = this.data.relation;
      this.numberAtributes = this.attributes.filter((x:any)=> x.editable == 1).length;

      this.main.ShowLoading();
      this.storeS.getAtributesRules().subscribe((x:any)=>{
        this.main.HideLoading();
        this.atributeRules = x.data.map((val: any) => ({
          ...val,
          aux: 0,
          data_regla: val.data_regla ? JSON.parse(val.data_regla) : null
        }));
      });
    }

  ngOnInit(): void {
    console.log(this.attributes, this.dataRow, this.relation);
  }

  
  obtenerFechaFormateada() {
    const datePipe = new DatePipe('en-US');
    return datePipe.transform(this.startDate, 'dd/MM/yyyy');
  }

  save(id : any, value: any,  date : any):void{
    //console.log(id, this.dataRow.id,  value, date)
    this.fullStoreAtributeData = JSON.parse(JSON.stringify(this.dataRow));
    if(this.validateMinMax(id, value)){
    if(this.validateUpcommingValue(id)){
    if(value != ""){
      this.fullStoreAtributeData[this.attributes.filter((x:any)=> x.id == id )[0].name] = value;
   //   if(this.validateRules()){
        this.main.ShowLoading();
        let tempDATE = date.length != 0 ? this.main.convertToDate(date) : new Date();
        let newSTDATE = ""
        newSTDATE = tempDATE.toISOString().slice(0, 10);
        const attribute = this.attributes.find((x: any) => x.id === id);
        this.storeS.newValue({ atributo_id : id, sucursal_id : this.dataRow.id, new_value : value , new_value_date : newSTDATE}).subscribe(
          (result:any) => {
            this.main.HideLoading();
            this.storeS.applyAtributeRules(this.dataRow.id).subscribe((x:any)=>{ console.log("done this") });     
            if(result.message == "Success") {
              Swal.fire({
                icon: 'success',
                title: 'Guardado',
                text: this.attributes.filter((x:any)=> x.id == id )[0].name + ': Valor de atributo programado correctamente'          
              }).then(() => {                       
                this.dialogRef.close({ reload: true });
              });
            }
          },
           (err:any) => {
            this.main.HideLoading();
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: this.attributes.filter((x:any)=> x.id == id )[0].name + ': Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
            });
          }
        );
      //}
  }
  }else{
      Swal.fire({
        icon: 'warning',
        title: 'Ya hay un cambio en cola',
        text: this.attributes.filter((x:any)=> x.id == id )[0].name + ': Ya existe un cambio en cola para este atributo'
      });
     }
  }
  }


  async savePart(id: any, value: any, date: any): Promise<void> {
    value = value ?? '';

    const tempDATE = date && date.length !== 0 ? this.main.convertToDate(date) : new Date();
    const newSTDATE = tempDATE.toISOString().slice(0, 10);

    try {
      const result: any = await this.storeS.newValue({ 
        atributo_id: id, 
        sucursal_id: this.dataRow.id, 
        new_value: value, 
        new_value_date: newSTDATE 
      }).toPromise();

      if (result.message === "Success") {
        if (result.data && result.data.length > 0) {
          const ruleAlert = result.data[0];
          if (ruleAlert.tipo_regla === 1) { 
            const sourceAttributeName = this.attributes.find((x: any) => x.id == id)?.name;
            const targetAttributeName = ruleAlert.atributo;
            this.errorsMessages += `${sourceAttributeName}: No se actualizó. El cambio sobrepasaría el límite del atributo '${targetAttributeName}'. `;
          }
        } else {
          console.log("Guardado exitoso para el atributo", id, result);
        }
      }
    } catch (err) {
      console.log(err);
      this.errorsMessages += `${this.attributes.find((x: any) => x.id == id)?.name}: Ocurrió un error al guardar este registro. `;
    }
  }

  comprobateCount :number = 0;
  saveCount :number = 0;

  validateRules(): boolean{
    for (const rule of this.atributeRules) {
      // Validación de suma
      if (rule.tipo === 1 && rule.data_regla) {
          let sumaAux = 0;
          const attrEx = this.attributes.find((x: any) => x.id === rule.id_atributo);
          console.log(rule, attrEx, "Se evaluó la regla");          
          let valueEvaluate = this.fullStoreAtributeData[attrEx?.name] == "" || this.fullStoreAtributeData[attrEx?.name] == undefined ? 0 : parseInt(this.fullStoreAtributeData[attrEx?.name]);
          let nameEvaluate = attrEx?.name
          for (const id_r of rule.data_regla.attributes) {
              const attr = this.attributes.find((x: any) => x.id === id_r);
              if (!attr) continue;
 
              const value = this.fullStoreAtributeData[attr.name];
              sumaAux += !value ? 0 : parseInt(value, 10);
          }

          console.log("Resultado SUMA ", attrEx?.name, "sumaTotal " + sumaAux,"se evalua con " + valueEvaluate);
          if (sumaAux > valueEvaluate) {
            console.log(rule.nombre + " activada");
            Swal.fire({
              icon: 'warning',
              title: 'Revise los datos',
              text: rule.nombre + ': La suma de los atributos relacionados no puede ser mayor que el valor de '+ nameEvaluate +' por la regla ' + rule.nombre 
            });
              return false; 
          }
      }
     }
     return true; 
  }

  fullStoreAtributeData : any = {};

  comprobate(id : any, value: any,  date : any):void{
    if(value != null && value.length > 0 ){
      if(this.validateMinMaxSilent(id, value)){
        if(this.validateUpcommingValue(id)){
        }else{
            this.validationsMessages = this.validationsMessages + this.attributes.filter((x:any)=> x.id == id )[0].name + ': Ya existe un cambio en cola para este atributo  '
        }
      }
      this.fullStoreAtributeData[this.attributes.filter((x:any)=> x.id == id )[0].name] = value;
    }else{
      this.fullStoreAtributeData[this.attributes.filter((x:any)=> x.id == id )[0].name] = this.dataRow[this.attributes.filter((x:any)=> x.id == id )[0]?.name];
    }
    // this.validationSubject.next(this.validationSubject.value +  1)
  }

  async comprobateAll(){
    this.fullStoreAtributeData = JSON.parse(JSON.stringify(this.dataRow));
    this.validationsMessages = "";

    const editableAttributes = this.attributes.filter((x: any) => x.editable == 1);
    for (const att of editableAttributes) {
      if (this.changedAttributeIds.has(att.id)) {
        if (att.type_id === 3) {
          const matSelect = this.matSelects.find(s => s.id === `input3-${att.id}`);
          if (matSelect) {
            this.comprobate(att.id, matSelect.value, '');
          }
        } else {
          const inputElement = document.querySelector(`#input${att.type_id}[data-att-id="${att.id}"]`) as HTMLInputElement;
          if (inputElement) {
              this.comprobate(att.id, inputElement.value, ''); 
          }
        }
      }
    }

    if (this.validationsMessages.length == 0) {
        this.saveAll();
    } else {
        Swal.fire({
            icon: 'warning',
            title: 'Revise los atributos con alertas antes de guardar',
            text: this.validationsMessages
        });
    }
  }

  async saveAll() {
    this.main.ShowLoading();
    this.errorsMessages = "";

    const editableAttributes = this.attributes.filter((x: any) => x.editable == 1);
    const dataToSave: any = { id: this.dataRow.id };

    for (const att of editableAttributes) {
      if (!this.changedAttributeIds.has(att.id)) {
        continue;
      }

      let value = '';
      if (att.type_id === 3) {
        value = this.matSelects.find(s => s.id === `input3-${att.id}`)?.value ?? '';
      } else if (att.type_id === 1) {
        value = this.booleanSelects.find(s => s.id === `input1-${att.id}`)?.value ?? '';
      } else {
        const inputElement = document.querySelector(`#input${att.type_id}[data-att-id="${att.id}"]`) as HTMLInputElement | null;
        value = inputElement?.value ?? '';
      }

      dataToSave[att.name] = value;
    }

    if (Object.keys(dataToSave).length === 1) {
      this.main.HideLoading();
      Swal.fire({
        icon: 'info',
        title: 'Sin cambios',
        text: 'Selecciona al menos un atributo para guardar.'
      });
      return;
    }

    try {
      const result: any = await this.storeS.setStoreAtributesMasiveValue({ data: [dataToSave] }).toPromise();

      this.uploadWarnings = (result?.validaciones ?? []).map((warning: any) => ({
        ...warning,
        sucursal: this.dataRow.nombre ?? this.dataRow.Nombre ?? warning.sucursal
      }));
      if (this.uploadWarnings.length > 0) {
        this.matDialog.open(StoresAttrValidationComponent, {
          panelClass: 'dialogs-lg',
          data: this.uploadWarnings
        });
        return;
      }

      if (result?.message !== 'Success') {
        throw new Error('La actualización masiva no fue exitosa');
      }

      Swal.fire({
        icon: 'success',
        title: 'Proceso terminado',
        text: 'Atributos guardados correctamente'
      }).then(() => {
        this.dialogRef.close({ reload: true });
      });
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: 'error',
        title: 'Error al guardar',
        text: 'Ocurrió un error al guardar los atributos, por favor vuelve a intentarlo.'
      });
    } finally {
      this.main.HideLoading();
    }
  }

  markAttributeChanged(id: number): void {
    this.changedAttributeIds.add(id);
    this.clearedAttributeIds.delete(id);
  }

  clearAttribute(att: any): void {
    if (this.isAttributeCleared(att.id)) {
      this.clearedAttributeIds.delete(att.id);
      this.changedAttributeIds.delete(att.id);
      return;
    }

    this.changedAttributeIds.add(att.id);
    this.clearedAttributeIds.add(att.id);

    if (att.type_id === 3) {
      const matSelect = this.matSelects.find(s => s.id === `input3-${att.id}`);
      if (matSelect) {
        matSelect.value = '';
      }
      return;
    }

    if (att.type_id === 1) {
      const matSelect = this.booleanSelects.find(s => s.id === `input1-${att.id}`);
      if (matSelect) {
        matSelect.value = '';
      }
      return;
    }

    const inputElement = document.querySelector(`#input${att.type_id}[data-att-id="${att.id}"]`) as HTMLInputElement | null;
    if (inputElement) {
      inputElement.value = '';
    }
  }

  isAttributeCleared(id: number): boolean {
    return this.clearedAttributeIds.has(id);
  }

  hasCurrentValue(value: any): boolean {
    return value !== null && value !== undefined && String(value).trim().length > 0;
  }

  converToObject(obj: string){
    try{
      return JSON.parse(obj);
    }catch(ex){
      return [];
    }
  }

  validateUpcommingValue(atributo_id : number) : boolean{
    return this.relation.filter((x:any)=> x.atributo_id == atributo_id && x.new_value_date != null).length == 0;
  }

  getRanges(rangeSelect : string){
    return rangeSelect.split("-");
  }

  validateMinMax(id: number, value : string){
    if(this.attributes.filter((x:any)=> x.id == id )[0].type_id == 6){
      if(parseInt(value) < 0){
        Swal.fire({
          icon: 'warning',
          title:  this.attributes.filter((x:any)=> x.id == id )[0].name + ': El valor no es válido',
          text: 'Ingrese un valor mayor a 0'
        });
      }
      return parseInt(value) >= 0;
    }

    if(this.attributes.filter((x:any)=> x.id == id )[0].type_id == 4){
     let minmax = this.getRanges(this.attributes.filter((x:any)=> x.id == id )[0].select_data);
     if(parseInt(value) < parseInt(minmax[0]) || parseInt(value)> parseInt(minmax[1])){
        Swal.fire({
          icon: 'warning',
          title:  this.attributes.filter((x:any)=> x.id == id )[0].name + ': El valor se sale del rango establecido',
          text: 'Ingrese un valor de ' + minmax[0] + ' a ' + minmax[1]
        });
        return false;
    }else{
      return true;
    }
     }else{
      return true;
     }
  }

  validateMinMaxSilent(id: number, value : string){
    if(this.attributes.filter((x:any)=> x.id == id )[0].type_id == 6){
        if(parseInt(value) < 0) {
            this.validationsMessages = this.validationsMessages + this.attributes.filter((x:any)=> x.id == id )[0].name + ': El valor no puede ser menor que 0 '
        }
        
        return parseInt(value) >= 0;
    }

    if(this.attributes.filter((x:any)=> x.id == id )[0].type_id == 4){
     let minmax = this.getRanges(this.attributes.filter((x:any)=> x.id == id )[0].select_data);
     if(parseInt(value) < parseInt(minmax[0]) || parseInt(value)> parseInt(minmax[1])){
        this.validationsMessages = this.validationsMessages + this.attributes.filter((x:any)=> x.id == id )[0].name + ': El valor se sale del rango establecido  '
        return false;
    }else{
      return true;
    }
     }else{
      return true;
     }
  }
}
